import { createApp } from 'vue'
const CLASS_NAME_FADER = 'js-fader'

document.addEventListener('DOMContentLoaded', () => {
  const elementsFader = document.getElementsByClassName(CLASS_NAME_FADER)
  if (!elementsFader.length) return

  Array.from(elementsFader).forEach((element) => {
    createApp({
      name: 'SectionsFader',
      data() {
        return {
          currentIndex: 0,
          items: [],
        }
      },
      mounted() {
        this.items = Array.from(this.$refs.items.children)
        if (!this.items.length) return
        const maxHeight = this.items.reduce(
          (mh, element) => Math.max(mh, element.offsetHeight),
          0
        )
        this.$refs.items.style.height = `${maxHeight}px`
        this.items.forEach((item, index) => {
          item.style.height = `${maxHeight}px`
          item.style.opacity = index === 0 ? 1 : 0
          item.style.pointerEvents = index === 0 ? 'auto' : 'none'
        })
      },
      methods: {
        setCurrentIndex(index) {
          if (!this.items.length) return
          this.currentIndex = (index + this.items.length) % this.items.length
          this.items.forEach((item, i) => {
            item.style.opacity = i === this.currentIndex ? 1 : 0
            item.style.pointerEvents = i === this.currentIndex ? 'auto' : 'none'
          })
        },
      },
    }).mount(element)
  })
})
